import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { reportService } from "../../../Services/report.service";
import { globalServices } from "../../../Services/global.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { AuthContext } from "../../../Contexts/AuthContext";
import AsyncSelect from "react-select/async";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocStore,
    updateLocTab,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { control } = useForm();

  const { userId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [update, setUpdate] = useState(new Date());

  const isTenant = Number(localStorage.getItem("tenantId")) > 0;
  const [search, setSearch] = useState({
    tenantId: isTenant ? Number(localStorage.getItem("tenantId")) : null,
    tenantOnly: !isTenant,
  });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
    totalSize: 0,
  });
  useEffect(() => {
    updateLocName("invoices-invoicesUnfiscalizedAccounts");
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  useEffect(() => {
    setIsLoading(true);
    reportService
      .invoicesUnfiscal(
        search.tenantId,
        pagination.pageIndex,
        pagination.pageSize,
        search.tenantOnly
      )
      .then((res) => {
        setPagination({ ...pagination, totalSize: res.data.totalCount });
        setReports(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [search, update]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        return result;
      })
      .catch((err) => err);
  };

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "tenantName",
      text: translator("Onboarding-DataVerification-RowTitle-Tenant"),
    },
    {
      dataField: "posTag",
      text: translator("Report-View-TableHeader-PosTag"),
      hidden: search.tenantOnly,
    },
    {
      dataField: "storeTag",
      text: translator("Report-View-TableHeader-StoreTag"),
      hidden: search.tenantOnly || isMobile,
    },
    {
      dataField: "invoicesSum",
      text: translator("Report-View-TableHeader-InvoicesSum"),
    },

    {
      dataField: "totalValue",
      text: translator("Report-View-TableHeader-TotalValue"),
      formatter: currencyFormatter,
      hidden: isMobile,
    },
  ];

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Main-Sidebar-InvoicesUnfiscalizedAccounts")}</span>
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row">
              <div className="form-group col-lg-3 col-md-6 col-sm-6 col-xs-12">
                <label htmlFor="ddlTenants">
                  {translator("InvIssReport-Filters-Tenants")}
                </label>
                <Controller
                  as={AsyncSelect}
                  control={control}
                  name="tenantId"
                  onChange={function (event) {
                    if (event[1].action === "clear") {
                      setSearch({
                        ...search,
                        tenantId: null,
                        tenantOnly: true,
                      });
                    } else {
                      setSearch({
                        ...search,
                        tenantId: event[0].id,
                        tenantOnly: false,
                      });
                    }
                    setPagination({
                      ...pagination,
                      pageIndex: 0,
                    });
                  }}
                  isClearable={true}
                  isDisabled={isTenant}
                  defaultOptions={true}
                  defaultValue={
                    isTenant
                      ? {
                          id: Number(localStorage.getItem("tenantId")),
                          label: localStorage.getItem("tenantName"),
                          value: localStorage.getItem("tenantName"),
                        }
                      : ""
                  }
                  loadOptions={promiseOptions}
                  placeholder={translator("Select-Tenant")}
                />
              </div>
            </form>
          </fieldset>
          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              totalSize={pagination.totalSize}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
